import { render } from "./i-fake-ticket.vue?vue&type=template&id=3c01cd31&scoped=true"
import script from "./i-fake-ticket.vue?vue&type=script&lang=js"
export * from "./i-fake-ticket.vue?vue&type=script&lang=js"

import "./i-fake-ticket.vue?vue&type=style&index=0&id=3c01cd31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c01cd31"]])

export default __exports__